import Immutable from 'immutable';
import guid from '../../../../../libraries/utils/guid';
import { VIDEO } from './types';
import getDomain from './abilities/get-domain';
import getImageUrl from './abilities/get-image-url';

var VideoEntityFields = Immutable.Record({
  id: guid(),
  type: VIDEO,
  imageId: null,
  originalHeight: 0,
  originalWidth: 0,
  mediaHeight: 0,
  mediaWidth: 0,
  thumbnailHeight: 0,
  thumbnailWidth: 0,
  title: null,
  embed: null,
  url: null
});

class VideoEntity extends VideoEntityFields {
  getDomain() {
    return getDomain(this.get('url'));
  }
  getThumbnailUrl(options) {
    options = Object.assign({}, options, { crop: 'scale' });
    return getImageUrl(
      this.get('imageId'),
      this.get('thumbnailHeight'),
      this.get('thumbnailWidth'),
      options
    );
  }
  getMediaImageUrl(options) {
    options = Object.assign({}, options, { crop: 'scale' });
    return getImageUrl(
      this.get('imageId'),
      this.get('mediaHeight'),
      this.get('mediaWidth'),
      options
    );
  }
  parse(data) {
    if (!data) {
      return this;
    }

    var fields = {};

    [
      'id',
      'imageId',
      'originalHeight',
      'originalWidth',
      'mediaHeight',
      'mediaWidth',
      'thumbnailHeight',
      'thumbnailWidth',
      'title',
      'embed',
      'url'
    ].forEach(field => (fields[field] = data[field] !== undefined ? data[field] : this.get(field)));

    var newVideoEntity = new VideoEntity(fields);
    return Immutable.is(this, newVideoEntity) ? this : newVideoEntity;
  }
  toJSON() {
    return {
      id: this.get('id'),
      type: this.get('type'),
      imageId: this.get('imageId'),
      originalHeight: this.get('originalHeight'),
      originalWidth: this.get('originalWidth'),
      mediaHeight: this.get('mediaHeight'),
      mediaWidth: this.get('mediaWidth'),
      thumbnailHeight: this.get('thumbnailHeight'),
      thumbnailWidth: this.get('thumbnailWidth'),
      title: this.get('title'),
      embed: this.get('embed'),
      url: this.get('url')
    };
  }
  static fromJSON(json) {
    return new VideoEntity().parse(json);
  }
}

export default VideoEntity;
